import { render } from "./ShareTemplateModel.vue?vue&type=template&id=3220cd26&scoped=true"
import script from "./ShareTemplateModel.vue?vue&type=script&lang=js"
export * from "./ShareTemplateModel.vue?vue&type=script&lang=js"

import "./ShareTemplateModel.vue?vue&type=style&index=0&id=3220cd26&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3220cd26"]])

export default __exports__